import {Box, Container, Typography} from "@mui/material";
import DataFilter from '../../components/DataFilter';
import CardSeguros from "./cardSeguros";
import { categoriaSeguros, dataSeguros } from "../../data/dataSeguros";
import {ScrollStatic} from "../../components/common/ScrollItem";
import TextToSpeech from "../../components/TextToSpeech";

const Seguros = () => {
    const accessibilityText = `
      Consulta las aseguradoras en la barra de busquedas, tambien puedes filtrar por tipo y en orden alfabetico.
    `;
  return (
    <Box
      sx={{
        width: "100%",
        minHeight: "100%",
        backgroundSize: "100% 20%",
        backgroundRepeat: "no-repeat",
        mb: { xs: "5px", sm: "10px" },
        overflow: "auto",
      }}
    >
      <Container
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          pt: { xs: 15 },
          maxWidth: "100% !important",
          pl: "0 !important",
          pr: "0 !important",
        }}
      >
        {/* <TextToSpeech text={accessibilityText} /> */}

        <ScrollStatic>
          <Typography
            variant="h1"
            align="center"
            sx={{
              width: "100%",
              color: "#194AC1",
              p: "0 35px"
            }}
          >
            Seguros
          </Typography>
        </ScrollStatic>

        <ScrollStatic>
          <DataFilter categoriasList={categoriaSeguros} categoriaIgual1="tipo" categoriaIgual2="subtipo" categoriaIgual3="subtipo_1" dataItem={dataSeguros} dataBusqueda="titulo" labelBusqueda={"Buscar seguro"} labelSelect={"Tipo de Seguro"} ComponentView={CardSeguros} GridXs={12} GridSm={12} GridMd={6} GridLg={4} /> 
        </ScrollStatic>
      </Container>
    </Box>
  );
};

export default Seguros;
